import { Outlet } from 'react-router-dom';
import { Footer } from './Footer';
import { TopBar } from './TopBar';

/**
 * 应用外壳：顶栏 + 内容 + 页脚，移动端额外挂底部导航。
 *
 * 布局要点（批次 5-4 完善）：
 * - 移动端优先：内容区左右留 20px，正文最大宽度受控，长行不跨屏；
 * - 底部导航固定在安全区之上（`env(safe-area-inset-bottom)` 适配 iPhone）；
 * - 内容区底部预留导航高度，避免最后一段被遮住。
 */
export function AppShell() {
  return (
    <div className="flex min-h-dvh flex-col bg-background text-foreground">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:rounded-md focus:bg-primary focus:px-3 focus:py-1.5 focus:text-primary-foreground"
      >
        跳到主要内容
      </a>

      <TopBar />

      <main id="main" className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
